// Palavras que ligam as respostas da ficha a cada equipe.
// É o único lugar a mexer quando a direção quiser ajustar os termos.
// A comparação ignora acento e maiúsculas — a normalização é feita na busca.

export interface EquipeDicionario {
  // Chave curta usada para casar com o nome da equipe na tela.
  id: string;
  // Rótulo de exibição (maiúsculas).
  nome: string;
  // Termos procurados no texto das respostas (radicais valem).
  palavras: string[];
}

export const DICIONARIO_EQUIPES: EquipeDicionario[] = [
  {
    id: 'cozinha',
    nome: 'COZINHA',
    palavras: [
      'cozinha',
      'cozinhar',
      'cozinheir',
      'comida',
      'panela',
      'fogão',
      'almoço',
      'merenda',
      'confeit',
      'bolo',
      'padeir',
      'churrasc',
    ],
  },
  {
    id: 'apoio',
    nome: 'APOIO',
    palavras: [
      'trabalhos manuais',
      'carregar',
      'montar',
      'força',
      'carreto',
      'caminhão',
      'mudança',
      'arrumar',
      'consertar',
      'marcenaria',
    ],
  },
  {
    id: 'bem estar',
    nome: 'BEM ESTAR',
    palavras: [
      'acolher',
      'acolhida',
      'cuidar',
      'escutar',
      'ouvir',
      'abraço',
      'carinho',
      'hospitalidade',
      'atenção',
      'paciência',
    ],
  },
  {
    id: 'intercessao',
    nome: 'INTERCESSÃO',
    palavras: [
      'oração',
      'orar',
      'rezar',
      'intercessão',
      'terço',
      'adoração',
      'capela',
      'silêncio',
      'contemplat',
    ],
  },
  {
    id: 'musica',
    nome: 'MÚSICA',
    palavras: [
      'violão',
      'cantar',
      'canto',
      'música',
      'instrumento',
      'teclado',
      'bateria',
      'coral',
      'ministério de música',
      'louvor',
    ],
  },
  {
    id: 'animacao',
    nome: 'ANIMAÇÃO',
    palavras: [
      'animação',
      'dança',
      'teatro',
      'dinâmica',
      'brincadeira',
      'alegria',
      'palhaç',
      'gincana',
      'recreação',
    ],
  },
  {
    id: 'lideres',
    nome: 'LÍDERES',
    palavras: [
      'liderança',
      'liderar',
      'coordenar',
      'já servi',
      'já fui líder',
      'catequista',
      'ministro',
      'coordenador',
      'professor',
    ],
  },
  {
    id: 'anjos da noite',
    nome: 'ANJOS DA NOITE',
    palavras: [
      'vigília',
      'madrugada',
      'noite',
      'dormir tarde',
      'plantão',
      'segurança noturna',
    ],
  },
  {
    id: 'ordem',
    nome: 'ORDEM',
    palavras: [
      'organização',
      'organizar',
      'ordem',
      'disciplina',
      'segurança',
      'portaria',
      'controle',
    ],
  },
  {
    id: 'secretaria',
    nome: 'SECRETARIA',
    palavras: [
      'digitar',
      'computador',
      'planilha',
      'secretári',
      'administrat',
      'escritório',
      'documento',
      'cadastro',
    ],
  },
  {
    id: 'saude',
    nome: 'SAÚDE',
    palavras: [
      'enfermeir',
      'médic',
      'saúde',
      'primeiros socorros',
      'farmácia',
      'técnic de enfermagem',
      'fisioterap',
    ],
  },
  {
    id: 'limpeza',
    nome: 'LIMPEZA',
    palavras: ['limpeza', 'limpar', 'faxina', 'organizar ambiente', 'banheiro'],
  },
  {
    id: 'multimidia',
    nome: 'MULTIMÍDIA',
    palavras: [
      'foto',
      'fotografia',
      'filmar',
      'vídeo',
      'edição',
      'projetor',
      'som',
      'iluminação',
      'transmissão',
      'design',
    ],
  },
];

// Remove acentos e deixa tudo minúsculo para comparar.
export function normalizar(texto: string): string {
  return texto
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}